const listChar = ['\n', '.', ';', ',', ' ']

/**
 *
 * @param {String} text - Texto a fragmentar
 * @param {Object} options
 * @param {number} options.limit - maximo de caracteres por fragmentos
 * @param {Object} options.lastLimit
 * @param {"min"|"none"} options.priority - Indica si se quiere el mínimo de fragmentos posibles.
 */
const parser = (text, options) => {
  let { limit, lastLimit, priority } = options
  if (lastLimit) priority = ''
  if (!lastLimit) lastLimit = limit
  const size = text.length
  if (size <= lastLimit) return [text]
  let thd
  if (priority === 'min') {
    const splitNum = Math.ceil(size / limit)
    thd = Math.ceil(size / splitNum)
  } else if (size > limit) {
    thd = parseInt(limit / 2)
  } else {
    thd = parseInt(text.length - lastLimit)
    limit = Math.min(limit, thd + parseInt(lastLimit / 2))
  }
  let firstHalf = text.substr(0, thd)
  let secondHalf = text.substr(thd, limit - thd)
  const thirdHalf = text.substr(limit)
  let isBreak = false
  for (const splitChar of listChar) {
    if (secondHalf.indexOf(splitChar) !== -1) {
      const index = secondHalf.lastIndexOf(splitChar)
      firstHalf += secondHalf.substr(0, index) + splitChar
      secondHalf = secondHalf.substr(index + 1) + thirdHalf
      isBreak = true
      break
    }
  }
  if (!isBreak) {
    firstHalf += secondHalf
    secondHalf = thirdHalf
  }
  secondHalf.trim()
  const newSplits = parser(secondHalf, { limit, lastLimit, priority })
  return [firstHalf].concat(newSplits)
}

export default function (text, options = {}) {
  return parser(text, options)
}